import React, { Component } from 'react';
import $ from 'jquery';
import LazyLoad from 'libs/lazyload';

/* eslint import/no-anonymous-default-export: [2, {"allowAnonymousFunction": true}] */
export default function(WrappedComponent) {
    return class WithStatus extends Component {
        lazyLoad = () => {
            LazyLoad($('.section'), 0, function() {
                const container = $(this);
                const aninodes = container.addClass('animated').find('[data-animation]');

                aninodes.each((i, elem) => $(elem).addClass($(elem).attr('data-animation')));
            });
        };

        componentDidMount() {
            this.lazyLoad();
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    lazyLoad={() => window.console && console.log('非必要调用，请移除该调用。')}
                />
            );
        }
    };
}
